<div class="asc-repricing-formula">
  <math xmlns="http://www.w3.org/1998/Math/MathML">
    <mrow>
      <mi>
        <strong>Risk Ratio</strong>
      </mi>
      <mo>=</mo>
      <mfrac>
        <mrow>
          <mi>Inventory</mi>
        </mrow>
        <mrow>
          <mi>Restock Day</mi>
          <mo>×</mo>
          <mi>Velocity</mi>
        </mrow>
      </mfrac>
      <ng-container *ngIf="!isWrap;else wrap" >
        <mo>=</mo>
        <mfrac>
          <mrow>
            <mn>{{ repricingItem?.context?.inventory }}</mn>
          </mrow>
          <mrow>
            <mn>{{ repricingItem?.context?.restockDays }}</mn>
            <mo>×</mo>
            <mn>{{ repricingItem?.context?.velocity }}</mn>
          </mrow>
        </mfrac>
        <mo>=</mo>
        <mn>
          <strong>{{
            repricingItem?.riskRatio ||
              (repricingItem?.state === "MISSING_PRICE" ? "N/A" : 0)
          }}</strong>
        </mn>
      </ng-container>
    </mrow>
  </math>
</div>
<ng-template #wrap>
  <mrow>
    <mi>
      <strong>Risk Ratio</strong>
    </mi>
    <mo>=</mo>
    <mfrac>
      <mrow>
        <mn>{{ repricingItem?.context?.inventory }}</mn>
      </mrow>
      <mrow>
        <mn>{{ repricingItem?.context?.restockDays }}</mn>
        <mo>×</mo>
        <mn>{{ repricingItem?.context?.velocity }}</mn>
      </mrow>
    </mfrac>
    <mo>=</mo>
    <mn>
      <strong>{{
        repricingItem?.riskRatio ||
          (repricingItem?.state === "MISSING_PRICE" ? "N/A" : 0)
      }}</strong>
    </mn>
  </mrow>
</ng-template>
